import styled from "styled-components";

const ease = "cubic-bezier(0.2, 0.7, 0.2, 1)";

export const TeamCarouselWrapper = styled.div`
  /* The slider inside is absolutely positioned: the container only has a
     height because it stretches with the row, so only the arrows centre. */
  .rec-carousel {
    justify-content: center;
  }
  .rec-slider-container {
    width: 1140px;
  }
  .rec-item-wrapper {
    height: 100%;
  }
`;

export const CarouselArrow = styled.button`
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 56px;
  height: 56px;
  margin: 0 28px;
  padding: 0;
  border: 1.5px solid rgba(250, 251, 255, 0.6);
  border-radius: 50%;
  background: transparent;
  color: #fafbff;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease, transform 0.3s ${ease};
  svg {
    width: 22px;
    height: 22px;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  &:hover {
    background: #fafbff;
    border-color: #fafbff;
    color: #0043ff;
    transform: scale(1.06);
  }
  &:active {
    transform: scale(0.95);
  }
  &:focus-visible {
    outline: 3px solid #02c5ff;
    outline-offset: 3px;
  }
  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    margin: 0 10px;
    svg {
      width: 18px;
      height: 18px;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
